import React, { useState, useEffect } from "react";
import { Column } from "@ant-design/plots";

const StackColumnChartPartner = ({ data, color, xLabel, yLabel, series, yAxisLabel, xAxisLabel, isStack, xField }) => {

  const [chartColor, setChartColor] = useState([]);

  useEffect(() => {
    loadData();
  }, []);

  const loadData = () => {

    if (color == "Public") {
      setChartColor(["#4945a8", "#724dad"]);
    } else {
      setChartColor(["#2193ae", "#32669e"]);
    }
  };

  const config = {
    data,
    scale: {
      color: {
        range: chartColor
      },
    },
    stack: true,
    xField: xField,
    yField: yLabel,
    colorField: 'type',
    label: {
      text: 'value',
      position: 'inside',
    },
    legend: {
      color: {
        title: false,
        position: 'bottom',
        rowPadding: 5,
      },
    },
    axis: {
      x: {
        title: xAxisLabel,
        style: {
          titleFill: 'black'
        }
      },
      y: {
        title: yAxisLabel,
        style: {
          titleFill: 'black'
        }
      }
    }
  };

  return <Column {...config} />;
};

export default StackColumnChartPartner;
